import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { SingleField } from '../fields/SingleField';
import { getOpenFieldsAndSections, toggleOpenFieldSection } from '../store';
import { Protocols, UpdatedOpinionField } from '../store/types';
import styles from './OpinionSection.module.scss';
import { SectionWrapper } from './SectionWrapper';

interface ProtocolsProps {
    protocols: Protocols;
    previousProtocols: Protocols | null;
    isEditing: boolean;
    isUpdating: boolean;
    fieldsUpdated: UpdatedOpinionField[];
}

export const ProtocolsSection: React.FC<ProtocolsProps> = ({ protocols, previousProtocols, isEditing, isUpdating, fieldsUpdated }) => {
    const dispatch = useAppDispatch();
    const openFieldsAndSections = useAppSelector(getOpenFieldsAndSections);
    const getFieldOpen = useCallback((id: string) => openFieldsAndSections.includes(id), [openFieldsAndSections]);
    const toggleFieldOpen = useCallback((id: string) => dispatch(toggleOpenFieldSection(id)), [dispatch]);
    const sectionId = 'protocols';
    const { closeOutAmountProtocol, negativeInterestProtocol } = protocols;

    const getPreviousField = useCallback((fieldId: keyof Protocols) => !isNull(previousProtocols) && previousProtocols[fieldId] || null, [previousProtocols]);

    return (
        <SectionWrapper id={sectionId} label='Protocols' isEditing={isEditing} isUpdating={isUpdating}>
            <div className={styles.protocolsSectionWrapper}>
                <div className={styles.sectionHeaderLabel}>Under the laws of the jurisdiction under consideration:</div>
                <SingleField
                    field={closeOutAmountProtocol}
                    previousField={getPreviousField('closeOutAmountProtocol')}
                    fieldId='closeOutAmountProtocol'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                    positiveAnswers={['No']}
                    negativeAnswers={['Yes', 'Yes - with exceptions']}
                />
                <SingleField
                    field={negativeInterestProtocol}
                    previousField={getPreviousField('negativeInterestProtocol')}
                    fieldId='negativeInterestProtocol'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                    positiveAnswers={['No']}
                    negativeAnswers={['Yes', 'Yes - with exceptions']}
                />
            </div>
        </SectionWrapper>
    );
};
